import { IPagination } from "../models/IPagination";
import { IPlayer } from "../models/IPlayer";
import { ITeamPlayer } from "../models/IMatch";
import api from "../services/api";
import qs from "qs";

export const getPlayerById = (id: string): Promise<{ data: IPlayer }> => api.get(`Player/${id}`);

export const deletePlayer = (id: string) => api.delete(`Player?playerId=${id}`);

export const searchPlayers = (search: string): Promise<{ data: ITeamPlayer[] }> => {
  const queryParams = new URLSearchParams();
  if (search) queryParams.append("search", search);

  return api.get(`Player/suggestions/all?${queryParams.toString()}`);
};

export const getPlayerList = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  sortBy?: "firstname" | "createdat" | "nationality" | "tshirtsize" | "gender",
  sortOrder?: "desc" | "asc",
  genderFilter?: string[],
  nationalityFilter?: string[],
  tshirtSizeFilter?: string[],
  languagesFilter?: string[],
  verifiedFilter?: string,
  bannedFilter?: string,
  lifeMemberFilter?: string,
  playaResidentFilter?: string
): Promise<{
  data: { items: IPlayer[]; pagination: IPagination };
}> => {
  const params: Record<string, any> = {
    pageNumber,
    pageSize,
    sortBy: sortBy || "firstName",
    sortOrder: sortOrder || "asc",
  };

  if (search) params.search = search;
  if (genderFilter?.length) params.genderFilter = genderFilter;
  if (nationalityFilter?.length) params.nationalityFilter = nationalityFilter;
  if (tshirtSizeFilter?.length) params.tshirtSizeFilter = tshirtSizeFilter;
  if (languagesFilter?.length) params.languageFilter = languagesFilter;
  if (verifiedFilter) params.verifiedFilter = verifiedFilter;
  if (bannedFilter) params.bannedFilter = bannedFilter;
  if (lifeMemberFilter) params.lifeMemberFilter = lifeMemberFilter;
  if (playaResidentFilter) params.playaResidentFilter = playaResidentFilter;

  return api.get("Player/all", {
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getPlayerDemographics = (
  tournamentId?: string
): Promise<{
  data: {
    totalPlayers: number;
    genderCounts: { gender: string; count: number }[];
    nationalityCounts: { nationality: string; count: number }[];
    tshirtSizeCounts: { tshirtSize: string; count: number }[];
  };
}> => api.get(`Player/demographics${tournamentId ? `?tournamentId=${tournamentId}` : ""}`);

export const getPlayerNationalities = () => api.get("Player/nationalities");

export const getPlayerRegistrationTrends = (tournamentId?: string) =>
  api.get(`Player/trends${tournamentId ? `?tournamentId=${tournamentId}` : ""}`);

export const assignAward = (award: { playerId: string; awardId: string }) => api.put("Player/award/assign", award);

export const banPlayer = (playerId: string, reason?: string) => api.put(`Player/ban/${playerId}`, { reason });

export const unbanPlayer = (playerId: string) => api.put(`Player/unban/${playerId}`);
